import PropTypes from 'prop-types';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import Schema from './schema';

const Data = (props) => {
  const { data, block, onChangeBlock } = props;

  const schema = Schema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

Data.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default Data;
